import React from 'react';
import { ErrorMessage } from './AdditionalErrorMessage.styled';

const AdditionalErrorMessage = ({ additionalErrorMessage }) => {
	return <ErrorMessage>{additionalErrorMessage}</ErrorMessage>;
};

export default AdditionalErrorMessage;
